<template>
    <MainPage :isMyProfle="true" v-if="formData && !isRestoreForm">
        <template v-slot:header>
            <div class="header-title">
                {{ lbl.myprofile.title }}
            </div>
            <!-- <div class="header-bar">
                <div class="header-title">
                    <img class="icon-back" src="@/assets/icon/icon-back.svg" alt="" @click="gotoMain()">
                    <div class="text">My Profile</div>
                    <div class="mock-div"></div>
                </div>
                <div class="profile-img-wrapper">
                    <ProfilePicture
                        ref="profile-picture"
                    ></ProfilePicture>
                    <div class="icon-camera" @click="clickSelectImageProfile()">
                        <img src="@/assets/icon/ic-camera.svg" alt="">
                    </div>
                </div>
            </div> -->
            <!-- <div class="header-text">{{formData.displayName}}</div> -->
            <!-- <div class="sub-header-text">{{formData.membershipUserName}}</div> -->
        </template>
        <div class="form-profile-container">
            <FormProfile
                ref="form-profile"
                :formData="formData"
                @onSubmitProfile="onSubmitProfile($event)"
                @changeNumber="changeNumber()"
            ></FormProfile>
        </div>
        <modal-master :controller="modalController"></modal-master>
    </MainPage>
</template>

<script>
// component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import FormProfile from '../component/FormProfile.vue';
// mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// model
// import {ProfileModel } from '@/core/Account/model/AccountModel'
//helper
import Account from "@/helper/AccountHelper.js"
// service
import BzbsOtp from '@/core/Otp/service/BzbsOtp'
import BzbsProfile from '@/core/Account/service/BzbsProfile'

export default {
    name: "MyProfile",
    mixins: [ModalMixin,LocaleMixin,ErrorApiMixin],
    components: {
    MainPage,
    FormProfile,
},
    data: function () {
        return {
            modalController: null,
            changeNumberModal: null,

            otpModal: null,
            fileUpload: null,
            file: null,

            formData: null,
            isRestoreForm: false,

            paramsProfile: null,
            storeType: null,

        }
    },
    created: async function () {
         let data = await Account.apiGetProfile();
         this.formData = data.profile;
    },
    mounted: function () {
    },
    methods: {
        gotoMain: function() {
            this.$router.back()
        },
        clickSelectImageProfile: function() {
            this.$refs['profile-picture'].clickSelectImageProfile();
        },
        onSubmitProfile:async function(storeTypeParams) {
            let params = this.$refs['form-profile'].getProfileValue()
            let extendjsonstring = JSON.stringify(storeTypeParams);
            // this.isRestoreForm = true;
            let success = await this.callApiUpdateProfile(params, extendjsonstring);
            if (success) {
                // this.isRestoreForm = true;
                // let data = await Account.apiGetProfile();
                // this.formData = data.profile;
                // this.isRestoreForm = false;
                window.location.reload()
            }
        },
        callApiUpdateProfile: function(params, extendjsonstring) {
            let token = Account.getToken();
            this.modalController.loadingModal.show();
            return new Promise((resolve) => {
                BzbsProfile.updateProfile(token, params, null, extendjsonstring, null, null ).subscribe((data) => {
                    console.log(data)
                    resolve(true);
                    this.modalController.loadingModal.hide();
                }, (err) => {
                    resolve(err);
                    this.modalController.loadingModal.hide();
                });
            });
        },
        changeNumber: function () {
            this.changeNumberModal
                    .clearModal()
                    .setTitle(this.lbl.myprofile.change_mobile_number.title)
                    .setMsg(this.lbl.myprofile.change_mobile_number.msg)
                    .setBtnCancel(this.lbl.myprofile.change_mobile_number.close)
                    .setBtnOk(this.lbl.myprofile.change_mobile_number.confirm)
                    .show()
            this.changeNumberModal.onClickOk((objData) => {
                let contactNumber = objData.contactNumber;
                this.showOtpModal(contactNumber);
            })
        },
        showOtpModal: function(contactNumber) {
            //set loadingModal & alertModal
            this.modalController.otpModal.setLoadingModal(this.modalController.loadingModal);
            this.modalController.otpModal.setAlertModal(this.modalController.alertModal);
            //start otp
            this.modalController.otpModal.startOtp(contactNumber, 'contact_number')
            this.modalController.otpModal.onSubmitOtp(async (objDta)=>{
                let tel = objDta.tel;
                let refcode = objDta.refcode;
                let otp = objDta.otp;
                let success = await this.callApiChangeNumber(tel, refcode, otp);
                if (success) {
                    this.modalController.otpModal.hide();
                    this.modalController.alertModal
                        .clearModal()
                        .setTitle("Update Password successfully")
                        .setMsg("Your password has been changed successfully. Use your new passwoed to login")
                        .setBtnOk("Login now")
                        .show();
                    this.modalController.alertModal.onClickOk(async () => {
                        this.isRestoreForm = true;
                        let data = await Account.apiGetProfile();
                        this.formData = data.profile;
                        this.isRestoreForm = false;
                    })
                }
            })
        },
        callApiChangeNumber: function (tel, refcode, otp) {
            let token = Account.getToken();
            return new Promise((resolve) => {
                BzbsOtp.ChangeNumber(token, tel, refcode, otp).subscribe((data) => {
                    console.log(data);
                    resolve(true);
                }, (err) => {
                    if(err.code == 409 && err.id == 2091){
                         this.modalController.otpModal.showError(tel, refcode);
                         this.modalController.otpModal.show();
                    }else{
                        this.modalController.otpModal.hide();
                        this.errorApi(err);
                    }
                    resolve(false);
                });
            });
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '@/style/base/base.scss';
    @import "../style/MyProfile.scss";
</style>
